import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasSectionComponent } from './gas-section.component';
import { GasScrollModule } from '../../utils/gas-scroll/gas-scroll.module';

const COMPONENTS = [
  GasSectionComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasScrollModule,
  ],
})
export class GasSectionModule { }
